import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { LicenseInfo } from '@mui/x-license';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './config/providers.tsx';
import './main.css';

// Initialize i18n BEFORE React renders
import './i18n/config';

// After a redeploy an already-open tab still references the old
// content-hashed chunk filenames in its bootstrap. The next lazy import
// 404s and Vite emits `vite:preloadError`. Reload once so the browser
// fetches the new index.html (and the new chunk hashes); the
// sessionStorage flag prevents reload loops if the new build is itself
// broken.
const PRELOAD_RELOAD_FLAG = 'vite-preload-reload';
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (sessionStorage.getItem(PRELOAD_RELOAD_FLAG) === '1') return;
  sessionStorage.setItem(PRELOAD_RELOAD_FLAG, '1');
  window.location.reload();
});
window.addEventListener('load', () =>
  sessionStorage.removeItem(PRELOAD_RELOAD_FLAG),
);

LicenseInfo.setLicenseKey(
  '51d0761e412c70f52d34b7863f9821e6Tz0xMTkxNDcsRT0xNzg5Nzc1OTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsS1Y9Mg==',
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <Providers />
    </Suspense>
  </StrictMode>,
);
